import { NodeType } from '@/types/tree';

export const isSubmissionsTabEnabled = ({
  assetSubmissionFeature,
  currentSelectedType,
  canManageSubmissionLinks,
  canViewPrivateTabs,
  isManagePage,
}: {
  assetSubmissionFeature: boolean;
  currentSelectedType: NodeType;
  /** read:links in config/rolePermissions.php is archivist/owner only, unlike a bare
   * authenticated-user check, which an administrator would also pass. */
  canManageSubmissionLinks: boolean;
  /** Off on a public share page, like every other tab that isn't share-viewing content. */
  canViewPrivateTabs: boolean;
  isManagePage: boolean;
}) =>
  assetSubmissionFeature &&
  currentSelectedType === NodeType.Folders &&
  canManageSubmissionLinks &&
  canViewPrivateTabs &&
  !isManagePage;
